<template>
  <div class="demo-home">
    <div class="demo-home__inner">
      <section class="demo-home__hero">
        <p class="demo-home__eyebrow">시작하기</p>
        <h1 class="demo-home__title">바톤 데이터 데모</h1>
        <p class="demo-home__lead">
          메뉴마다 다른 예시 화면이 준비되어 있습니다. 차트와 모니터링 화면을
          둘러보며 가볍게 체험해 보세요.
        </p>
        <p class="demo-home__note">표시 데이터는 실제와 무관한 샘플입니다.</p>
      </section>

      <el-row :gutter="24" class="demo-home__cards">
        <el-col :xs="24" :sm="12" :md="8">
          <router-link to="/dashboard" class="demo-home__card-link">
            <el-card shadow="hover" class="demo-home__card">
              <span class="demo-home__card-icon-wrap" aria-hidden="true">
                <i class="el-icon-s-data demo-home__card-icon" />
              </span>
              <h2 class="demo-home__card-title">운영 대시보드</h2>
              <p class="demo-home__card-desc">
                이커머스 운영 지표 · 매출·채널·카테고리 샘플
              </p>
              <span class="demo-home__card-hint">화면 이동</span>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <router-link to="/factory" class="demo-home__card-link">
            <el-card shadow="hover" class="demo-home__card">
              <span class="demo-home__card-icon-wrap" aria-hidden="true">
                <i class="el-icon-s-grid demo-home__card-icon" />
              </span>
              <h2 class="demo-home__card-title">공장 라인</h2>
              <p class="demo-home__card-desc">
                가동·OEE·공정 온도 등 제조 라인 보드 샘플
              </p>
              <span class="demo-home__card-hint">화면 이동</span>
            </el-card>
          </router-link>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <router-link to="/finance" class="demo-home__card-link">
            <el-card shadow="hover" class="demo-home__card">
              <span class="demo-home__card-icon-wrap" aria-hidden="true">
                <i class="el-icon-coin demo-home__card-icon" />
              </span>
              <h2 class="demo-home__card-title">경영 손익</h2>
              <p class="demo-home__card-desc">
                월별 매출·이익 추이·판관 구성·손익표 요약
              </p>
              <span class="demo-home__card-hint">화면 이동</span>
            </el-card>
          </router-link>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemoHome",
};
</script>

<style lang="scss" scoped>
.demo-home {
  width: 100%;
  min-height: min(720px, calc(100vh - 96px));
  padding: 40px 28px 80px;
  box-sizing: border-box;
}

.demo-home__inner {
  max-width: 1040px;
  margin: 0 auto;
}

.demo-home__hero {
  margin-bottom: 36px;
  padding-bottom: 28px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.demo-home__eyebrow {
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #254aa5;
  opacity: 0.85;
}

.demo-home__title {
  margin: 0 0 14px;
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  letter-spacing: -0.035em;
  line-height: 1.25;
}

.demo-home__lead {
  margin: 0 0 12px;
  max-width: 52em;
  font-size: 15px;
  line-height: 1.7;
  color: #606266;
}

.demo-home__note {
  margin: 0;
  padding: 8px 12px;
  display: inline-block;
  font-size: 12px;
  line-height: 1.45;
  color: #909399;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.demo-home__cards {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.demo-home__card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  margin-bottom: 20px;
  height: 100%;
}

.demo-home__card {
  position: relative;
  height: 100%;
  border-radius: 12px;
  border: 1px solid #e4e7ed;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.2s;
  overflow: hidden;
}

.demo-home__card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #254aa5, #4a90e2);
  opacity: 0;
  transition: opacity 0.22s ease;
}

.demo-home__card-link:hover .demo-home__card {
  transform: translateY(-3px);
  border-color: #c6d9f5;
  box-shadow: 0 12px 32px rgba(37, 74, 165, 0.12);
}

.demo-home__card-link:hover .demo-home__card::before {
  opacity: 1;
}

.demo-home__card-link:hover .demo-home__card-hint {
  color: #254aa5;
}

.demo-home__card-link:hover .demo-home__card-icon {
  transform: scale(1.05);
}

.demo-home__card ::v-deep .el-card__body {
  padding: 22px 20px 20px;
  display: flex;
  flex-direction: column;
  min-height: 200px;
  box-sizing: border-box;
}

.demo-home__card-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: linear-gradient(160deg, #eef3fb 0%, #e2eaf8 100%);
  border: 1px solid rgba(37, 74, 165, 0.1);
  flex-shrink: 0;
}

.demo-home__card-icon {
  display: block;
  margin: 0;
  font-size: 24px;
  color: #254aa5;
  transition: transform 0.2s ease;
}

.demo-home__card-title {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 600;
  color: #303133;
  letter-spacing: -0.02em;
}

.demo-home__card-desc {
  margin: 0;
  flex: 1;
  font-size: 13px;
  line-height: 1.55;
  color: #909399;
}

.demo-home__card-hint {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f0f2f5;
  font-size: 12px;
  font-weight: 500;
  color: #a8abb2;
  transition: color 0.2s ease;
}

.demo-home__card-hint .el-icon-top-right {
  margin-left: 4px;
  font-size: 11px;
  vertical-align: middle;
}

@media (max-width: 992px) {
  .demo-home {
    min-height: auto;
    padding: 28px 20px 48px;
  }

  .demo-home__title {
    font-size: 24px;
  }
}
</style>
